var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"is-primary","outlined":"","size":_vm.size,"icon-left":"plus","loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }